export default {
  namespaced: true,
  state: {
    isEdit: false, //購物車內品項是否有編輯過(無參數詳細比對，只要有按鈕操作就有編輯)
    isView: false, //是否是瀏覽模式
    addons_charge: 0, //加料加總金額存放(不放在menu_item裡因為會觸發isEdit=true)
    tab: {},
    menu_item: {
      item_id: null,
      item: null,
      quantity: 1,
      detail: {
        size: null,
        temperature: null,
        sweetness: null,
        add_on: [],
      },
      discounts: [],
      note: null,
      input_price: 0,
      can_show_detail: true,
      edit_permission: {
        size: true,
        temperature: true,
        sweetness: true,
        add_on: true,
        quantity: true,
        discount: true,
        note: true,
      },
      free_addons: 0,
      print_label: true,
    },
  },

  getters: {
    getMenuItem: (state) => state.menu_item,
    chooseTab: (state) => state.tab,
    chooseItem: (state) => state.menu_item.item,
    chooseQuantity: (state) => state.menu_item.quantity,
    chooseDiscount: (state) => state.menu_item.discounts,
    getNote: (state) => state.menu_item.note,
    getItemName: (state) => state.menu_item.item?.label,
    getItemValue: (state) => state.menu_item.item?.value,
    getFreeAddonsAmount: (state) => state.menu_item.free_addons,
    getAddonsCharge: (state) => state.addons_charge,
    getDetail: (state) => state.menu_item.detail,
    getItemId: (state) => state.menu_item.item_id,
    getItemPrice: (state) => state.menu_item.input_price,
    getSubtotal: (state) => state.menu_item.subtotal,
    getCanDelete: (state) => state.menu_item.can_delete,
    getCanEdit: (state) => state.menu_item.edit_permission,
    getCanDuplicate: (state) => state.menu_item.can_duplicate,
    getCanShowDetail: (state) => state.menu_item.can_show_detail,
    getIsEdit: (state) => state.isEdit,
    isMenuDetail: (state) => {
      if (state.menu_item.item && !state.isView) return true;
      return false;
    },
  },

  mutations: {
    SET_TAB(state, data) {
      state.tab = data;
      state.menu_item.item = null;
    },
    SET_MENU_ITEM(state, data) {
      state.menu_item = data;
    },
    SET_ITEM(state, data) {
      state.menu_item.item = data;
    },
    SET_FREE_ADD_ONS(state, data) {
      state.menu_item.free_addons = data;
    },
    SET_QUANTITY(state, data) {
      state.menu_item.quantity = data;
    },
    SET_DISCOUNT(state, data) {
      state.menu_item.discounts = data;
    },
    SET_NOTE(state, data) {
      state.menu_item.note = data;
    },
    SET_PRINT_LABEL(state, data) {
      state.menu_item.print_label = data;
    },
    SET_DETAIL(state, data) {
      switch (data.kind) {
        case 'size':
          state.menu_item.detail.size = data.value;
          break;
        case 'temperature':
          state.menu_item.detail.temperature = data.value;
          break;
        case 'sweetness':
          state.menu_item.detail.sweetness = data.value;
          break;
        case 'add_on': {
          const ing_arr = state.menu_item.detail.add_on;
          const index = ing_arr.findIndex((e) => e.value === data.value.value);
          if (index === -1) {
            ing_arr.push(data.value);
          } else {
            ing_arr.splice(index, 1);
          }
          break;
        }
      }
    },
    SET_MORE_ADD_ON(state, data) {
      state.menu_item.detail.add_on = data;
    },
    SET_ITEM_PRICE(state, data) {
      state.menu_item.input_price = data;
    },
    SET_ADD_ONS_CHARGE(state, data) {
      state.addons_charge = data;
    },
    SET_IS_EDIT(state, data) {
      state.isEdit = data;
    },
    SET_IS_VIEW(state, data) {
      state.isView = data;
    },
    RESET(state) {
      state.isEdit = false;
      state.addons_charge = 0;
      state.menu_item = {
        item_id: null,
        item: null,
        quantity: 1,
        detail: {
          size: null,
          temperature: null,
          sweetness: null,
          add_on: [],
        },
        discounts: [],
        note: null,
        input_price: 0,
        can_show_detail: true,
        edit_permission: {
          size: true,
          temperature: true,
          sweetness: true,
          add_on: true,
          quantity: true,
          discount: true,
          note: true,
        },
        free_addons: 0,
        print_label: true,
      };
    },
  },

  actions: {
    //選擇商品tab
    doSetTab({ commit }, data) {
      commit('SET_TAB', data);
      //建立商品tab相對應的商品清單
      const length = data.products?.length;
      const list_data = {
        totalPage: length > 30 ? Math.ceil((length - 2) / 28) : 1,
        total: length,
        data: data.products,
      };
      commit('list/SET_ITEM_LIST', list_data, { root: true });
    },
    //選擇一個無detail的商品品項(全新)
    doSetItem({ commit, rootGetters, dispatch }, data) {
      commit('SET_ITEM', data);
      const { size, temperature, sweetness, discount_list, free_addons } =
        rootGetters['list/getAllProducts'][data.value];
      //mapping該品項的detail buttons
      dispatch('doSetDetailBtnsAndDefault', { size, temperature, sweetness });
      //mapping該品項的折扣清單
      commit('list/SET_DISCOUNT_LIST', discount_list, { root: true });
      commit('SET_FREE_ADD_ONS', free_addons);
    },
    //建立detail buttons清單+預設口味(全新)
    doSetDetailBtnsAndDefault({ commit, getters, rootGetters }, data) {
      commit('list/SET_DETAIL_BTNS', data, { root: true });
      const default_value = rootGetters['list/getAllProducts'][getters.getItemValue].detail;
      const handle_add_on_default = (size) => {
        const check_add_on = rootGetters['list/getAllProductsAddOn'][size].map((e) => e.value);
        default_value.add_on.forEach((e) => {
          if (check_add_on.includes(e.value)) {
            const setData = { kind: 'add_on', value: e };
            commit('SET_DETAIL', setData);
          }
        });
      };
      const check = Object.keys(data);
      check.forEach((item) => {
        //處理容量/冷熱/甜度的選項
        if (data[item]?.length === 0) {
          const setData = { kind: item, value: 'no-select' };
          commit('SET_DETAIL', setData);
        } else if (data[item]?.length === 1) {
          if (item === 'size') {
            //容量選項price_type為1時才能強制選擇
            if (data[item][0]?.price_type !== 1) return;
            commit('SET_ITEM_PRICE', data[item][0]?.select_price[0]);
            //有預設容量後處理預設加料
            if (default_value.add_on.length > 0) handle_add_on_default(data[item][0].value);
          }
          const setData = { kind: item, value: data[item][0].value };
          commit('SET_DETAIL', setData);
        } else {
          //處理預設口味(容量/冷熱/甜度)
          const check_array = rootGetters['list/getDetailBtns'][item].map((e) => e.value);
          if (check_array.includes(default_value[item])) {
            if (item === 'size') {
              const allSize = rootGetters['list/getAllProducts'][getters.getItemValue].size;
              allSize.forEach((e) => {
                if (e.value === default_value[item] && e.price_type === 1) {
                  //type1才能預設
                  commit('SET_DETAIL', { kind: 'size', value: default_value[item] });
                  //有預設容量後處理顯示金額
                  commit('SET_ITEM_PRICE', e.select_price[0]);
                  //有預設容量後處理預設加料
                  if (default_value.add_on.length > 0) handle_add_on_default(default_value[item]);
                }
              });
            } else {
              const setData = { kind: item, value: default_value[item] };
              commit('SET_DETAIL', setData);
            }
          }
        }
      });
    },
    //選擇一個有detail的商品品項(購物車內商品)
    doSetItemDetail({ commit, rootGetters, dispatch }, data) {
      commit('SET_MENU_ITEM', data);
      //mapping該品項的detail buttons
      if (rootGetters['list/getAllProducts'][data.item.value]) {
        const { size, temperature, sweetness, discount_list, free_addons } =
          rootGetters['list/getAllProducts'][data.item.value];
        dispatch('doSetDetailBtns', { size, temperature, sweetness });
        //mapping該品項的折扣清單
        commit('list/SET_DISCOUNT_LIST', discount_list, { root: true });
        commit('SET_FREE_ADD_ONS', free_addons);
      } else {
        commit('SET_DETAIL', { kind: 'size', value: 'no-select' });
        commit('SET_DETAIL', { kind: 'temperature', value: 'no-select' });
        commit('SET_DETAIL', { kind: 'sweetness', value: 'no-select' });
      }
    },
    //建立detail buttons清單(購物車內商品)
    doSetDetailBtns({ commit }, data) {
      commit('list/SET_DETAIL_BTNS', data, { root: true });
      const check = Object.keys(data);
      check.forEach((item) => {
        //處理容量/冷熱/甜度的選項
        if (data[item]?.length === 0) {
          const setData = { kind: item, value: 'no-select' };
          commit('SET_DETAIL', setData);
        }
      });
    },
    doCancelItem({ commit }) {
      commit('RESET');
      commit('list/CLEAR_ITEM_DETAIL', '', { root: true });
    },
  },
};
